/**
 * Customer comments (blog/article widget) → Supabase Edge → Slack moderation.
 * Override for staging: VITE_CUSTOMER_COMMENT_SUBMIT_URL
 */
export const REVIEW_SUBMIT_URL =
  import.meta.env.VITE_CUSTOMER_COMMENT_SUBMIT_URL ??
  'https://sbknwbswqkneppxbkxto.supabase.co/functions/v1/customer-comment-submit';

/** @type {string | undefined} */
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Supabase Edge Functions expect apikey + Authorization: Bearer (anon) from browser clients.
 * @returns {Record<string, string>}
 */
export function reviewSubmitHeaders() {
  const key = SUPABASE_ANON_KEY ?? 'sb_publishable_b7t5J9eOKAjM82MMMNXH1w_USFmyb60';
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${key}`,
    apikey: key,
  };
}